import { Browse, Favourite, Gift, Gift2, Play, Reload, StarCircle, TicketStar } from '@shared/icons';
import type { IconProps } from '@shared/icons/types';
import React from 'react';
import type { NavigationTabParams } from '../types';

const AZIcon: React.ComponentType<IconProps> = ({ className }) =>
  React.createElement(
    'p',
    {
      className: `link-label-explanatory ${className || ''}`,
    },
    'A-Z'
  );

const discover = { id: 'discover', icon: StarCircle, trackName: 'Discover' } satisfies NavigationTabParams;
const browse = { id: 'browse', icon: Browse, trackName: 'Browse' } satisfies NavigationTabParams;
const purchases = { icon: TicketStar, id: 'purchases', trackName: 'Purchases' } satisfies NavigationTabParams;
const offers = { icon: Gift, id: 'offers', trackName: 'Offers' } satisfies NavigationTabParams;
const favourites = { icon: Favourite, id: 'favourites', trackName: 'Favourites' } satisfies NavigationTabParams;
const inPlay = { icon: Play, id: 'in_play', trackName: 'In-Play' } satisfies NavigationTabParams;
const myBets = { icon: Reload, id: 'my_bets', trackName: 'My Bets' } satisfies NavigationTabParams;
const allSports = { icon: AZIcon, id: 'sports', trackName: 'A-Z Sports', mobileOnly: true } satisfies NavigationTabParams;
const freeBets = { icon: Gift2, id: 'free_bets', trackName: 'Free Bets' } satisfies NavigationTabParams;

export { allSports, browse, discover, favourites, freeBets, inPlay, myBets, offers, purchases };
